<template>
  <div class="st-vue-loader">
    <v-progress-circular
      indeterminate
      color="#00aaa7"
      :size="80"
      :width="8"
    />
  </div>
</template>

<script>
export default {
  name: 'Loader',
};
</script>

<style lang="scss" scoped>
.st-vue-loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9;
}
</style>
